import {store} from '../../redux/store';
import {hideChooseSpecialtyModal, showChooseSpecialtyModal} from './reducer';
import {getLocalData, setLocalData} from '../../utils/storage/storage';
import {keys} from '../../api/keys';
import Config from 'react-native-config';

/**
 * This function open Choose Specialty modal
 */
export const openChooseSpecialtyModal = async () => {
  const {email} = store.getState()?.auth?.currentUser || {};
  if (Config.DEMO_EMAIL === email) {
    const isSeen = getLocalData(keys.CHOOSE_SPECIALITY_SEEN);
    if (!isSeen) {
      store.dispatch(showChooseSpecialtyModal());
    }
  }
};

/**
 * This function close Choose Specialty modal
 */
export const closeChooseSpecialtyModal = async () => {
  store.dispatch(hideChooseSpecialtyModal());
  setLocalData(keys.CHOOSE_SPECIALITY_SEEN, true);
};
